import React from 'react';
import { Button, Flex, Text } from '@chatsdet/ui';
import { PencilSimple, Trash, ClockCounterClockwise } from '@phosphor-icons/react';
import type { ApplicationContextItem } from '../types';

const SOURCE_LABELS: Record<string, string> = {
  bootstrap: 'Bootstrap',
  workflow: 'Workflow',
  manual: 'Manual',
  cli: 'CLI',
};

type Props = {
  item: ApplicationContextItem;
  onEdit: (item: ApplicationContextItem) => void;
  onDelete: (item: ApplicationContextItem) => void;
  onViewHistory: (item: ApplicationContextItem) => void;
};

export function ContextItemCard({ item, onEdit, onDelete, onViewHistory }: Props) {
  return (
    <div className="group flex items-start justify-between gap-3 py-2.5 px-3 rounded-md hover:bg-muted/50 transition-colors">
      <div className="min-w-0 flex-1">
        <Flex align="center" gap="sm">
          <Text size="sm" weight="medium" className="text-foreground">
            {item.itemLabel}
          </Text>
          <Text size="xs" className="text-muted-foreground">
            {SOURCE_LABELS[item.source] ?? item.source}
          </Text>
          {item.version > 1 && (
            <button
              onClick={() => onViewHistory(item)}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              v{item.version}
            </button>
          )}
        </Flex>
        <Text size="sm" className="text-muted-foreground mt-0.5 whitespace-pre-wrap">
          {item.content}
        </Text>
      </div>
      <Flex gap="xs" className="opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
        <Button
          variant="ghost"
          size="sm"
          onPress={() => onViewHistory(item)}
          aria-label="View history"
        >
          <ClockCounterClockwise size={14} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onPress={() => onEdit(item)}
          aria-label="Edit"
        >
          <PencilSimple size={14} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onPress={() => onDelete(item)}
          aria-label="Delete"
        >
          <Trash size={14} />
        </Button>
      </Flex>
    </div>
  );
}
